<ng-container [ngTemplateOutlet]="menuItemContent() || defaultItem"></ng-container>

<ng-template #defaultItem>
  @if (icon(); as icon) {
    <sxw-svg-icon [name]="icon.name" [width]="icon.size" [height]="icon.size" [strokeColor]="icon.strokeColor" [fillColor]="icon.strokeColor" />
  }
  @if (label(); as label) {
    <span>{{ label | translate }}</span>
  }
</ng-template>
